import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Form, Input, Modal, Segment} from "semantic-ui-react";
import Info from "../../../../components/Info";
import DragAndDrop from "../../../../components/DragAndDrop";
import ConfirmModal from "../../../../components/Modals/ConfirmModal";

const RepresentationModal = ({open, onClose, representation, columns, onSave, onDelete, loading}) => {
    const [form, setForm] = useState({})
    const [delOpen, setDelOpen] = useState(false)

    const onChange = (e, {value, checked, name}) => {
        setForm(f => ({
            ...f,
            [name]: checked || value
        }))
    }

    useEffect(() => {
        open && setForm(representation || {})
    }, [open, representation])

    const getItems = (isRight) => {
        const right = (form.columns || []).map(c => ({
            id: c.name,
            displayNameKey: (columns.find(col => col.id === c.name) || {}).displayNameKey
        }));
        if (isRight) return right;
        return columns.filter(col => !(right.map(c => c.id).includes(col.id)));
    }

    const onChangeDnd = (d) => {
        let cols = [];
        d.forEach((cl, i) => {
            const colData = (form.columns || []).find(c => c.name === cl.id);
            cols.push({
                ...colData,
                name: cl.id,
                order: i + 1
            })
        });
        onChange(null, {name: 'columns', value: cols})
    }

    return (
        <Modal
            closeIcon
            onClose={onClose}
            open={open}
            size="small"
            id="fieldModal"
        >
            <Modal.Header className='modal__label_center'>
                {representation ? `Настройка данных отчета` : 'Создать новый отчет'}
            </Modal.Header>
            <Modal.Content className='modal__content representation-content'>
                <div className='representation-content__name-block'>
                    <Form>
                        <Form.Field inline>
                            <label>Название</label>
                            <Input
                                value={form.name || ''}
                                name='name'
                                onChange={onChange}
                            />
                        </Form.Field>
                        {((representation || {}).isUserView || !representation) && <Form.Field className='result-step__item'>
                            <Checkbox
                                checked={form.isDefault || false}
                                name='isDefault'
                                onChange={onChange}
                            />
                            <div className='checkbox-label'>
                                Сделать основным
                                <Info
                                    name={'Основной отчет'}
                                    text={'Данный отчет будет открываться сразу при переходе в раздел “Мои отчеты”'}
                                />
                            </div>

                        </Form.Field>}
                    </Form>
                </div>
                <Segment vertical>
                    <div className='representation-content__dnd scroll-style'>
                        <DragAndDrop
                            key={'DragAndDrop'}
                            left={getItems()}
                            right={getItems(true)}
                            search={''}
                            t={(w) => w + ''}
                            onChange={onChangeDnd}
                            columns={[
                                {
                                    title: 'Неиспользуемые данные'
                                },
                                {
                                    title: 'Данные вашего отчета'
                                }
                            ]}
                        />
                    </div>
                </Segment>
            </Modal.Content>
            <Modal.Actions className='modal__actions modal__actions_with-description'>
                <div>
                    <Button loading={loading} disabled={loading} className='modal__actions_yes' onClick={() => onSave(form)}>ПОДТВЕРДИТЬ</Button>
                </div>
                <div className='modal-description'>
                    <div className='personal-data'>
                        Проверьте правильность данных и нажмите кнопку “Подтвердить”
                    </div>
                </div>
                {(representation && representation.isUserView) && <div className='m-t-7'>
                    <div className='personal-data'>
                        <a onClick={() => setDelOpen(true)}>Удалить отчет</a>
                    </div>
                </div>}
            </Modal.Actions>
            <ConfirmModal
                open={delOpen}
                onConfirm={() => {
                    onDelete(form.id);
                    onClose();
                }}
                setOpen={setDelOpen}
                label={'Удаление отчета'}
            >
                Вы действительно уверены, что хотите удалить отчет?
            </ConfirmModal>
        </Modal>
    );
};

export default RepresentationModal;


// WEBPACK FOOTER //
// ./App/pages/reports/components/representation/representationModal.jsx